<script setup lang="ts">
import { type HTMLAttributes, computed } from 'vue';
import {
	RadioGroupIndicator,
	RadioGroupItem,
	type RadioGroupItemProps,
	useForwardProps,
} from 'radix-vue';
import { cn } from '@laam/lib/utils';
import { PhCircle } from '@phosphor-icons/vue';

const props = defineProps<
	RadioGroupItemProps & { class?: HTMLAttributes['class']; svgSize?: string }
>();
const defaultSvgSize = '3xl';

const delegatedProps = computed(() => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<RadioGroupItem
		v-bind="forwardedProps"
		:class="
			cn(
				'aspect-square h-5xl w-5xl rounded-full border border-neutral-900 text-neutral-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-gray-700 bg-white',
				props.class,
			)
		"
	>
		<RadioGroupIndicator
			class="flex items-center justify-center [&_svg]:fill-current"
		>
			<PhCircle
				:class="`h-${props.svgSize || defaultSvgSize} w-${props.svgSize || defaultSvgSize}`"
				weight="fill"
				color="white"
			>
			</PhCircle>
		</RadioGroupIndicator>
	</RadioGroupItem>
</template>
